<template>
  <div class="content">
    <div class="pay-container">
      <div class="pay-card">
        <form>
          <!-- 标题 -->
          <div class="pay-header">
            <h2>修改资金密码</h2>
            <p>请谨慎操作，修改密码后请妥善保管</p>
          </div>

          <!-- 原密码 -->
          <div class="form-group">
            <label>原资金密码</label>
            <div class="input-group">
              <input v-model="password" type="password" placeholder="请输入原资金密码" maxlength="16" />
            </div>
          </div>

          <!-- 新密码 -->
          <div class="form-group">
            <label>新资金密码</label>
            <div class="input-group">
              <input v-model="paypassword" type="password" placeholder="密码由6位数字组成" maxlength="16" />
            </div>
          </div>

          <!-- 确认密码 -->
          <div class="form-group">
            <label>确认密码</label>
            <div class="input-group">
              <input v-model="paypassword1" type="password" placeholder="请再次输入密码" maxlength="16" />
            </div>
          </div>

          <!-- 提示 -->
          <p class="pay-tip">无法修改资金密码，<a @click="$parent.openKefu">联系客服</a></p>

          <!-- 提交按钮 -->
          <button type="button" class="submit-button" @click="isOk">确认</button>
        </form>

        <!-- 弹窗 -->
        <div class="pay-dialog" style="display: none">
          <div class="pay-password">
            <div class="pay-password__header">提示</div>
            <p class="pay-password__title"><span>请您先绑定手机号后，再设置资金密码</span></p>
            <div>
              <a href="javascript:void(0);" class="pay-password__button">前往设置</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modifyPayPassword',
  data() {
    return {
      password: null,
      paypassword: null,
      paypassword1: null
    };
  },
  methods: {
    isOk() {
      const info = {
        password: this.password,
        paypassword: this.paypassword
      };

      if (!this.password) return this.$parent.showTost(0, '请输入旧密码');
      if (!this.paypassword) return this.$parent.showTost(0, '请输入新密码');
      if (this.password.length < 6) return this.$parent.showTost(0, '请输入正确的旧密码长度');
      if (this.paypassword.length < 6) return this.$parent.showTost(0, '请输入正确的新密码长度');
      if (!this.paypassword1) return this.$parent.showTost(0, '请输入确认密码');
      if (this.paypassword !== this.paypassword1) return this.$parent.showTost(0, '两次密码不一致！');
      if (this.password === this.paypassword) return this.$parent.showTost(0, '新旧密码不能一致！');

      this.$parent.showLoading();
      this.$apiFun.post('/api/editPayPassword', info).then(res => {
        this.$parent.hideLoading();
        if (res.code !== 200) return this.$parent.showTost(0, res.message);
        this.$parent.showTost(1, res.message);
        this.$parent.getUserInfos();
      });
    }
  }
};
</script>

<style scoped>
.content {
  background-color: #f8fafc;
  min-height: 100vh;
  padding: 30px 15px;
  display: flex;
  justify-content: center;
  font-family: 'Helvetica', 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

/* 卡片 */
.pay-container {
  width: 100%;
  max-width: 500px;
}

.pay-card {
  background: #fff;
  border-radius: 16px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.08);
  width: 100%;
  box-sizing: border-box;
}

/* 标题 */
.pay-header {
  text-align: center;
  margin-bottom: 30px;
}

.pay-header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 6px;
}

.pay-header p {
  font-size: 14px;
  color: #718096;
}

/* 表单 */
.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #4a5568;
}

.input-group {
  width: 100%;
}

.input-group input {
  width: 100%;
  padding: 12px 15px;
  font-size: 14px;
  border-radius: 8px;
  border: 1px solid #cbd5e0;
  box-sizing: border-box;
  transition: all 0.2s;
}

.input-group input:focus {
  outline: none;
  border-color: #4a90e2;
  box-shadow: 0 0 0 2px rgba(66,153,225,0.2);
  background: #fff;
}

/* 提示文字 */
.pay-tip {
  font-size: 13px;
  color: #718096;
  margin: 10px 0 20px;
}

.pay-tip a {
  color: #4299e1;
  text-decoration: none;
}

.pay-tip a:hover {
  text-decoration: underline;
}

/* 提交按钮 */
.submit-button {
  width: 100%;
  padding: 14px;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  background: linear-gradient(135deg, #4a90e2, #63b3ed);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(66,153,225,0.2);
  box-sizing: border-box;
}

.submit-button:hover {
  background: linear-gradient(135deg, #3b82f6, #4299e1);
  transform: translateY(-2px);
  box-shadow: 0 6px 10px rgba(66,153,225,0.3);
}

.submit-button:active {
  transform: translateY(0);
}

/* 弹窗 */
.pay-dialog .pay-password {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  max-width: 380px;
  margin: 0 auto;
  text-align: center;
}

.pay-password__header {
  font-size: 16px;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 15px;
}

.pay-password__title span {
  font-size: 14px;
  color: #718096;
}

.pay-password__button {
  display: inline-block;
  margin-top: 15px;
  padding: 10px 25px;
  background: #4a90e2;
  color: #fff;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
}

.pay-password__button:hover {
  background: #3b82f6;
}

/* 响应式 */
@media (max-width: 480px) {
  .pay-card {
    padding: 20px;
  }

  .pay-header h2 {
    font-size: 20px;
  }

  .submit-button {
    padding: 12px 0;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/modifyPayPassword.vue